var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"page-title"},[_vm._v("\n  "+_vm._s(_vm.label)),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }